<template>
  <a-row type='flex'
         class="item">
    <a-col :span="2">
      <auto-icon :type='item.widgetSettings.icon' />
    </a-col>
    <a-col :span="8">
      <a-row class="title">
        {{ item.name }}
      </a-row>
      <a-row class="hint">
        {{ item.desc }}
      </a-row>
    </a-col>
    <a-col :span="10">
      <a-checkbox @change='onChange'
                  :checked='checked'>
      </a-checkbox>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AutoIcon } from '@iota-cn/ui-components'
import { computed } from 'vue'
import { useSysConfig } from '../../DefaultSystemPlugin'

const sysConfig = useSysConfig()

const props = defineProps(['item'])
const onChange = (e: any) => {
  sysConfig.updateSysconfig({ key: props.item.key, value: e.target.checked.toString() })
}

const checked = computed(() => {
  return props.item.value === 'true' || props.item.defaultValue === 'true'
})

</script>

<style>
</style>